import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponentDirective } from '@core/library/base.component';
import { AuthorizationService } from '@core/services/authorization.service';
import { DialogFactoryService } from '@core/services/dialog-factory.service';
import { MasterDataService } from '@core/services/master-data.service';
import { KMTAnalyticsService } from '@core/services/analytics.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'kmt-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
})
export class AnalyticsComponent
  extends BaseComponentDirective
  implements OnInit, OnChanges
{
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public masterService: MasterDataService,
    public authorizationService: AuthorizationService,
    public dialogFactory: DialogFactoryService,
    public analyticsService: KMTAnalyticsService,
    public sanitizer: DomSanitizer
  ) {
    super(router, route, masterService, authorizationService, dialogFactory);
  }
  public analyticsUrl: any;
  ngOnInit(): void {
    this.fetchAnalyticsURL();
  }
  async fetchAnalyticsURL() {
    this.analyticsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      (await this.analyticsService.fetchAnalyticsURL()) || ''
    );
  }
  ngOnChanges(changes: SimpleChanges): void {}
}
